import React from 'react'
import './SideNav.css'
import { BsCollection, BsFileBarGraph, BsPen, BsPeople, BsPerson } from 'react-icons/bs'
import { BiEnvelope, BiLogOutCircle, BiChevronLeft, BiChevronRight, BiMoney } from 'react-icons/bi'
import { RiInstallLine } from 'react-icons/ri'
import { NavLink } from 'react-router-dom'
import { API_URL } from '../config'

const NAV_ITEMS = [
  {
    section: 'WORKSPACE',
    items: [
      {
        label: 'Dashboard',
        icon: <BsFileBarGraph />,
        key: 'dashboard',
      },
      {
        label: 'Campaigns',
        icon: <BsCollection />,
        key: 'campaigns',
      },
      {
        label: 'Send email',
        icon: <BiEnvelope />,
        key: 'do-marketing',
      },
      {
        label: 'Transactions',
        icon: <BiMoney />,
        key: 'transactions-view',
      },
      {
        label: 'Customers',
        icon: <BsPeople />,
        key: 'customers',
      },
      {
        label: 'Feedback',
        icon: <BsPen />,
        key: 'feedback',
      },
    ],
  },
  {
    section: 'ACCOUNT',
    items: [
      {
        label: 'My Account',
        icon: <BsPerson />,
        key: 'profile',
      },
    ],
  },
]

const SideNav = ({ collapsed = false, onToggle, onNavigate }) => {
  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/apps/kscanner/logout.php`, {
        method: 'GET',
        credentials: 'include',
      })
    } catch (error) {
      console.error('Logout request failed:', error)
    } finally {
      localStorage.clear()
      window.location.href = '/login'
    }
  }

  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate()
    }
  }

  return (
    <aside className={`kx-sidenav ${collapsed ? 'is-collapsed' : ''}`}>
      <div className="kx-sidenav__top">
        <div className="kx-sidenav__control-row">
          {!collapsed && <span className="kx-sidenav__eyebrow">MENU</span>}

          <button
            type="button"
            className="kx-sidenav__toggle"
            onClick={onToggle}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? <BiChevronRight /> : <BiChevronLeft />}
          </button>
        </div>

        <nav className="kx-sidenav__navigation" aria-label="Main navigation">
          {NAV_ITEMS.map((section) => (
            <div className="kx-sidenav__section" key={section.section}>
              {!collapsed && <div className="kx-sidenav__section-label">{section.section}</div>}

              <ul className="kx-sidenav__list">
                {section.items.map(({ key, label, icon }) => (
                  <li className="kx-sidenav__item" key={key}>
                    <NavLink
                      to={`/${key}`}
                      exact
                      activeClassName="is-active"
                      className="kx-sidenav__link"
                      onClick={handleNavigate}
                      title={collapsed ? label : undefined}
                    >
                      <span className="kx-sidenav__icon" aria-hidden="true">
                        {icon}
                      </span>

                      {!collapsed && <span className="kx-sidenav__label">{label}</span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      <div className="kx-sidenav__bottom">
        <a
          href="https://play.google.com/store/apps/details?id=com.karamalescanner&hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="kx-sidenav__link kx-sidenav__install"
          title={collapsed ? 'Install Kscanner App' : undefined}
        >
          <span className="kx-sidenav__icon" aria-hidden="true">
            <RiInstallLine />
          </span>

          {!collapsed && <span className="kx-sidenav__label">Install Kscanner App</span>}

          {!collapsed && (
            <span className="kx-sidenav__external" aria-hidden="true">
              ↗
            </span>
          )}
        </a>

        <button
          type="button"
          className="kx-sidenav__link kx-sidenav__logout"
          onClick={handleLogout}
          title={collapsed ? 'Logout' : undefined}
        >
          <span className="kx-sidenav__icon" aria-hidden="true">
            <BiLogOutCircle />
          </span>

          {!collapsed && <span className="kx-sidenav__label">Logout</span>}
        </button>

        {!collapsed && (
          <div className="kx-sidenav__footer">
            <span className="kx-sidenav__footer-dot" />
            <span>Karamale Organiser</span>
          </div>
        )}
      </div>
    </aside>
  )
}

export default SideNav
